export const environment = {
  production: true
};



// WEBPACK FOOTER //
// /home/travis/build/Pedro-vk/Bet-Token-wallet/src/environments/environment.ts